module.exports = __webpack_public_path__ + "img/info-02.f603f952.jpg";